@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.BackgroundCircle {
  @extend %font-family-primary;

  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &.normal {
    width: 32px;
    height: 32px;
    padding: 11px;
  }

  &.highlight-purple {
    background-color: $theme-color-info;
  }
}
